import http from "@/utils/http";

export function AllApi(url, data, method) {
  let info = {
    url: "order-service/" + url,
    method: method,
  };

  if (method === "GET") {
    info.params = data;
  } else {
    info.data = data;
  }

  return http(info);
}
